var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#f6c708",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2340 5110 c-497 -47 -928 -216 -1340 -524 -122 -91 -375 -344 -466 -466 -260 -347 -415 -695 -489 -1097 -150 -813 100 -1639 680 -2242 350 -364 828 -627 1318 -726 198 -40 300 -49 522 -49 297 0 532 37 797 125 762 252 1368 856 1624 1620 92 274 128 503 128 809 0 303 -37 537 -126 804 -310 927 -1122 1601 -2088 1732 -133 18 -436 25 -560 14z m306 -1365 c54 -27 84 -60 102 -114 8 -24 12 -156 12 -442 l0 -408 423 -3 424 -3 48 -30 c135 -84 124 -280 -20 -346 -37 -17 -73 -19 -457 -19 l-418 0 0 -415 c0 -353 -2 -421 -15 -453 -69 -163 -301 -163 -370 0 -13 32 -15 100 -15 453 l0 415 -415 0 c-353 0 -421 2 -453 15 -149 63 -165 265 -27 350 l48 30 424 3 423 3 0 408 c0 424 2 447 44 504 26 35 110 77 156 77 20 0 59 -11 86 -25z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.17c6fa1ed550548aa108aa1c1a7bfdab.svg";
export { ForwardRef as ReactComponent };